import { useCallback, useEffect, useMemo, useState } from 'react';
import { SupportApiClient } from '@web-front/support-chat';

import { useAppSelector } from '../../hooks/redux';
import { selectCurrentToken } from '../../store/auth.slice';

const SUPPORT_API_BASE_URL = (import.meta as ImportMeta & { env?: Record<string, string> }).env
  ?.VITE_SUPPORT_API_BASE_URL;
const IS_PRODUCTION = (import.meta as ImportMeta & { env?: Record<string, string> }).env?.MODE === 'production';
const REFRESH_INTERVAL_MS = 120_000;

/** Number of specialist messages which have not yet been opened in a ticket. */
export function useSupportTicketUnreadCount(enabled = true) {
  const token = useAppSelector(selectCurrentToken);
  const [count, setCount] = useState(0);
  const api = useMemo(
    () => new SupportApiClient({ apiBaseUrl: SUPPORT_API_BASE_URL, getAccessToken: () => token || null }),
    [token],
  );

  const refresh = useCallback(async () => {
    if (!enabled || !token || (!SUPPORT_API_BASE_URL && IS_PRODUCTION)) {
      setCount(0);
      return;
    }

    try {
      const result = await api.getUnreadTicketMessageCount();
      setCount(Math.max(0, result.count));
    } catch {
      // A transient support API failure must not make the main menu unusable.
    }
  }, [api, enabled, token]);

  useEffect(() => {
    void refresh();
    const interval = window.setInterval(() => void refresh(), REFRESH_INTERVAL_MS);
    return () => window.clearInterval(interval);
  }, [refresh]);

  return count;
}
